import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import GoogleLoginButton from '../components/GoogleLoginButton';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

function Login() {
  const { login, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // 处理 Google OAuth 回调（服务器返回 token 或 error 参数）
  useEffect(() => {
    const token = searchParams.get('token');
    const oauthError = searchParams.get('error');
    if (token) {
      setLoading(true);
      // 服务器已验证 Google 登录，直接使用 JWT token
      localStorage.setItem('token', token);
      window.location.href = '/'; // 刷新页面以加载用户信息
    } else if (oauthError) {
      setError(decodeURIComponent(oauthError));
      // 清理 URL 参数
      window.history.replaceState({}, '', '/login');
    }
    // 也支持旧的隐式流回调（兼容）
    const hash = window.location.hash;
    if (hash && hash.includes('id_token=')) {
      const params = new URLSearchParams(hash.substring(1));
      const idToken = params.get('id_token');
      if (idToken) {
        window.history.replaceState({}, '', '/login');
        setLoading(true);
        loginWithGoogle(idToken)
          .then(() => navigate('/'))
          .catch(err => {
            setError(err.response?.data?.error || 'Google 登录失败');
            setLoading(false);
          });
      }
    }
  }, [searchParams, loginWithGoogle, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || '登录失败');
    }
    setLoading(false);
  };


  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>欢迎回来</h2>
        <p className="auth-subtitle">登录你的 RollSleeves 卷袖 账户</p>

        {error && <div className="error-message">{error}</div>}
        {loading && <div style={{ textAlign: 'center', padding: 16, color: 'var(--text-light)' }}>登录中...</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">邮箱</label>
            <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="your@email.com" required />
          </div>
          <div className="form-group">
            <label className="form-label">密码</label>
            <input className="form-input" type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="输入密码" required />
          </div>
          <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
            {loading ? '登录中...' : '登录'}
          </button>
        </form>

        {/* GSI 按钮（桌面端） */}
        <GoogleLoginButton onError={setError} />


        <p className="auth-footer" style={{ marginTop: 12 }}>
          <Link to="/forgot-password">忘记密码 / 邮箱验证码登录</Link>
        </p>
        <p className="auth-footer">
          还没有账户？<Link to="/register">注册</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
